import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { LcaService } from '../../../services/lca.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { NgForm } from '@angular/forms';
import { acceptedFileTypes } from 'app-models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-withdraw-lca',
    templateUrl: './withdraw-lca.component.html',
    styleUrls: ['./withdraw-lca.component.scss']
})
export class WithdrawLcaComponent implements OnInit {
    @Input() lca: any;
    @Output() hideEditButton: EventEmitter<any> = new EventEmitter();
    lcaWithdraw: any = {};
    disableButton: boolean = false;
    showFileUpload: boolean = true;
    lcaId: any;
    //IM-4325 - Removed 'LCA withdrawl doc' option in the document upload section of Create/edit LCA
    configurations = {
        inputMultipleFlag: false,
        fileType: acceptedFileTypes,
        isFileListRequired: true,
        categoryName: 'LCAWTDOC',
        entityId: 0,
        fileCategory: 'LCAWTDOC',
        listUploadedFiles: [],
        documentTypeRequired: false,
        docummentTypeCode: '',
        useCase: 'company',
        useCaseId: parseInt(sessionStorage.getItem('companyId'))
    };

    constructor(
        private toastr: ToastrService,
        private lcaApis: LcaService,
        public dialogRef: MatDialogRef<WithdrawLcaComponent>,
        @Inject(MAT_DIALOG_DATA) public lcaData,
    ) { }

    ngOnInit() {
        this.lcaWithdraw.statusCode = "LCAWTHDR";
        this.lcaId = sessionStorage.getItem('lcaId') || this.lcaData.id ? parseInt(sessionStorage.getItem('lcaId')) || this.lcaData.id : null;
        this.configurations.entityId = this.lcaId;
        this.configurations = Object.assign({}, this.configurations);
        if (this.lca.status.code === 'LCAWTHDR') {
            this.disableButton = true;
            this.lcaWithdraw.statusUpdatedDate = (this.lca.statusChangeDate) ? moment(this.lca.statusChangeDate).toISOString() : '';
            this.lcaWithdraw.statusChangeReason = this.lca.statusReason;
        } else {
            this.disableButton = false;
        }
    }

    saveWithdrawForm(f: NgForm) {
        if (f.invalid) {
            return false;
        }
        this.lcaWithdraw.statusUpdatedDate = moment(this.lcaWithdraw.statusUpdatedDate).format('YYYY-MM-DD');
        const payload = {
            notes: this.lcaWithdraw.statusChangeReason,
            withdrawnDate: this.lcaWithdraw.statusUpdatedDate,
            statusUpdatedDate: this.lcaWithdraw.statusUpdatedDate 
        }
        this.lcaApis.addWithdrawn(payload, this.lcaId).subscribe(response => {
            if (response['status'] === 200) {
                this.disableButton = true;
                this.lca = response['data'];
                this.hideEditButton.emit(this.lca)
                this.toastr.success(response['message'], 'Success');
                this.dialogRef.close(true);
            }
        });
    }
    onDismiss() {
      this.dialogRef.close(false);
    }
}
